// CUSTODY SETUP — the area's routes (UI rebuild batch 4, area `custody-admin`; reference build for the wallet lane).
// Mounted in App.tsx at /custody-admin/* behind uiV2(4) only. The custody section's builder (src/screens/v2/custody/)
// may instead mount these components under its own /custody/* — change BASE in components/v2/custody-admin/paths.ts.
import { CustodySigninShell } from '../../../components/v2/custody/SigninLine';
import { Routes, Route, Navigate } from 'react-router-dom';
import { DepositAddressesV2 } from './Addresses';
import { IssueAddressV2 } from './IssueAddress';
import { PayoutAddressesV2 } from './PayoutAddresses';
import { ProposeAddressV2 } from './ProposeAddress';
import { KeysV2 } from './Keys';
import { RegisterKeyV2 } from './RegisterKey';
import { CustodySettingsV2 } from './Settings';
import { CustodyFlowV2 } from './FlowGuide';

export { DepositAddressesV2, IssueAddressV2, PayoutAddressesV2, ProposeAddressV2, KeysV2, RegisterKeyV2, CustodySettingsV2, CustodyFlowV2 };

export function CustodyAdminRoutes() {
  return (
    <CustodySigninShell>
    <Routes>
      <Route index element={<Navigate to="guide" replace />} />
      <Route path="addresses" element={<DepositAddressesV2 />} />
      <Route path="addresses/new" element={<IssueAddressV2 />} />
      <Route path="payout-addresses" element={<PayoutAddressesV2 />} />
      <Route path="payout-addresses/new" element={<ProposeAddressV2 />} />
      <Route path="keys" element={<KeysV2 />} />
      <Route path="keys/register" element={<RegisterKeyV2 />} />
      <Route path="settings" element={<CustodySettingsV2 />} />
      <Route path="guide" element={<CustodyFlowV2 />} />
    </Routes>
    </CustodySigninShell>
  );
}
